import { TopicTile, InfoTile } from '.'
import RecentlyLaunched from '@/assets/images/icons/recently-launched.svg'
import UpNext from '@/assets/images/icons/up-next.svg'
import CurrentlyWorkingOn from '@/assets/images/icons/currently-working-on.svg'
import InDiscovery from '@/assets/images/icons/in-discovery.svg'

interface RoadmapTableProps {
    data: any | null;
    info: any | null;
}

const RoadmapTable: React.FC<RoadmapTableProps> = ({ data, info }) => {

    const inDiscovery =[] as any
    const upNext =[] as any
    const currentlyWorkingOn =[] as any
    const currentCampaigns =[] as any

    const phaseColor = (type: any) => {
        switch(type) {
            case 'jade':
                return {background: "bg-jade", text:"text-white", dot:"bg-lightjade"}
            break;
            case 'orange':
                return {background: "bg-orange", text:"text-white", dot:"bg-lightorange"}
            break;
            case 'rose gold':
                return {background: "bg-rosegold", text:"text-jade", dot:"bg-lightrosegold"}
            break;
            case 'grey':
                return {background: "bg-roadmapdarkgrey", text:"text-jade", dot:"bg-lightroadmapdarkgrey"}
            break;
            case 'blue':
                return {background: "bg-lightroadmapblue", text:"text-white", dot:"bg-lightblue"}
            break;
            default:
        }
    }

   data?.map((data: any)=>{
        data.data?.slices[0].primary.items?.map((item: any)=>{
            if(item.date_start !== null && item.date_end !== null) {
                let colorSet = [] as any
                switch(item.status) {
                    case 'In discovery':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        inDiscovery.push(item)
                    break;
                    case 'Up next':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        upNext.push(item)
                    break;
                    case 'Currently working on':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        currentlyWorkingOn.push(item)
                    break;
                    case 'Current campaigns':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        currentCampaigns.push(item)
                    break;
                }
            }
        })
    })

    const showDots = (id: any, dot: any) => {
        const selector = document.querySelectorAll('div.'+id);
    
        selector.forEach(element => {
            element.classList.toggle("hide");
        });
        dot.children[0]?.classList.toggle("on");
    }
    

    return (
        <div className="py-12">
            <div className="grid grid-cols-12 max-w-[1280px] mx-auto key">
                <div className="col-span-6">
                    <h3 className="text-[28px] font-semibold">Roadmap</h3>
                </div>
                <div className="col-span-6 flex justify-end">
                    <ul>
                        {data?.map((item: any, index: number)=>{
                            const bgColor = phaseColor(item.data.category_colour?.toLowerCase()) as any
                            return (
                                <li key={index} onClick={(e)=>showDots("topic-"+item.data.category_colour?.toLowerCase().replace(" ",""), e.target)} className=" inline-block cursor-pointer mr-[15px] text-xs">
                                    <span className={`w-[16px] h-[16px] rounded-[8px] inline-block mr-[5px] relative top-[4px] ${bgColor?.background}`}></span> 
                                    {item.data.category_heading}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div> 
            <div className="hidden lg:grid grid-cols-12 max-w-[1280px] mx-auto  my-16">
                {inDiscovery.length > 0 ? 
                <div className="col-span-3 text-center font-semibold text-[20px]"><InDiscovery className="h-24 block mx-auto mb-4"/><p>In discovery</p></div>
                :<></>}
                {upNext.length > 0 ? 
                <div className="col-span-3  text-center font-semibold text-[20px]"><UpNext className="h-24 block mx-auto mb-4"/><p>Up next</p></div>
                :<></>}
                {currentlyWorkingOn.length > 0 ? 
                <div className="col-span-3  text-center font-semibold text-[20px]"><CurrentlyWorkingOn className="h-24 block mx-auto mb-4"/><p>Currently working on</p></div>
                :<></>}
                {currentCampaigns.length > 0 ? 
                <div className="col-span-3 text-center font-semibold text-[20px]"><RecentlyLaunched className="h-24 block mx-auto mb-4"/><p>Live</p></div>
                :<></>}
            </div>
            <div className="grid grid-cols-12 gap-0 md:gap-6 max-w-[1280px] mx-auto topics pr-4">
                {inDiscovery.length > 0 ? 
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                        {inDiscovery.length > 0 ? 
                        <div className="col-span-12 md:hidden text-center font-semibold text-[20px] mt-12"><InDiscovery className="h-24 block mx-auto mb-4"/><p>In discovery</p></div>
                        :<></>}
                        <InfoTile info={info.primary.in_discovery} open/>
                        {inDiscovery?.map((item: any, index: number)=>{
                            return <TopicTile data={item} key={index} open={index}/>
                        })}
                    </div>
                :<></>}
                {upNext.length > 0 ? 
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    {upNext.length > 0 ? 
                        <div className="col-span-12 md:hidden text-center font-semibold text-[20px] mt-12"><UpNext className="h-24 block mx-auto mb-4"/><p>Up next</p></div>
                    :<></>}
                    <InfoTile info={info.primary.up_next} open/>
                    {upNext?.map((item: any, index: number)=>{
                        return <TopicTile data={item} key={index} open={index}/>
                    })}
                </div>
                :<></>}

                {currentlyWorkingOn.length > 0 ? 
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    {currentlyWorkingOn.length > 0 ? 
                        <div className="col-span-12 md:hidden text-center font-semibold text-[20px] mt-12"><CurrentlyWorkingOn className="h-24 block mx-auto mb-4"/><p>Currently working on</p></div>
                    :<></>}
                    <InfoTile info={info.primary.currently_working_on} open/>
                    {currentlyWorkingOn?.map((item: any, index: number)=>{
                        return <TopicTile data={item} key={index} open={index}/>
                    })}
                </div>
                :<></>}
                {currentCampaigns.length > 0 ? 
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    {currentCampaigns.length > 0 ? 
                    <div className="col-span-12 md:hidden text-center font-semibold text-[20px] mt-12"><RecentlyLaunched className="h-24 block mx-auto mb-4"/><p>Live</p></div>
                    :<></>}
                    <InfoTile info={info.primary.live} open/>
                    {currentCampaigns?.map((item: any, index: number)=>{
                        return <TopicTile data={item} key={index} open={index}/>
                    })}
                </div>
                :<></>}
            </div>
        </div>
    )

}

export default RoadmapTable;
